// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E_SF","buttons":"styles_buttons__V4bRT"};